import { Component, OnInit } from '@angular/core';
import { GlobalSettingsService } from '../../../../core/services/global-settings.service';

import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-alerts-settings',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './alerts-settings.component.html',
  styleUrl: './alerts-settings.component.css'
})
export class AlertsSettingsComponent implements OnInit {
  showAlertsSound = true;

  constructor(private globalSettings: GlobalSettingsService) {}

  ngOnInit(): void {
    this.showAlertsSound = this.globalSettings.getAlertChime();
  }

  onAlertSoundChange(): void {
    this.globalSettings.setAlertChime(this.showAlertsSound);
  }
}